import React from 'react'
import styles from '../List/User.module.css'

const User = ( { user} ) => {
    return (
        <div className={styles.user}>
        <div className={styles.name}>
            <p>{user.name} </p>
        </div>
        <div className={styles.buttons}>
            <button ><i className="far fa-trash-alt"></i></button>
        </div>
    </div>
    )
}

export default User
